import Big from "big.js";
import { cdnHost } from "@/nav-localized/config";

export function numberFormat(value: string, digit = 8, separator = true) {
  if (typeof value !== "string") {
    return value;
  }
  const [int, decimal] = value.split(".");
  if (digit > 0) {
    if (separator) {
      const newInt = int.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
      return `${newInt}${decimal ? "." + decimal.slice(0, digit) : ""}`;
    } else {
      return `${int}${decimal ? "." + decimal.slice(0, digit) : ""}`;
    }
  } else {
    return `${int}`;
  }
}

export function toNonExponential(num: number): string {
  const m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
  return num.toFixed(Math.max(0, (m?.[1] || "").length - Number(m?.[2] || 0)));
}

export function getPrecision(precision: string) {
  const number = toNonExponential(Number(precision));
  if (number) {
    if (number.includes(".")) {
      // 小数
      return number.slice(2).length;
    } else if (number === "1") {
      return 0;
    } else {
      return -(precision.length - 1);
    }
  } else {
    return 0;
  }
}

// transform USDT to $ or other
export const transformUSDT = (
  price: string,
  USDTRate = 1,
  rates = 1,
  symbolPrecision: string,
  symbol: string
) => {
  if (rates !== null && typeof window !== "undefined") {
    const p = new Big(price).times(USDTRate).times(rates).toFixed(2).toString();

    return ` ${symbol}${numberFormat(p, getPrecision(symbolPrecision))}`;
  } else {
    return "-";
  }
};

/**
 * 通过 Cloudflare CDN 对图片进行裁剪/压缩，避免直接请求原图。
 * 借鉴 apps/blofin-exchange/utils/format.ts 中的 clipImg 实现。
 *
 * @param url       原始图片 URL
 * @param width     目标宽度 (px)
 * @param height    目标高度 (px)
 * @param fit       裁剪模式，默认 "cover"
 * @param quality   压缩质量 0-100，默认 80
 * @returns         经 CDN 裁剪后的图片 URL；若 url 为空则返回空字符串
 */
export const clipImage = (
  url: string | undefined,
  width: number,
  height: number,
  fit: string = "cover",
  quality: number = 80
): string => {
  if (!url) return "";
  return `${cdnHost}/cdn-cgi/image/width=${width},height=${height},format=webp,quality=${quality},fit=${fit}/${url}`;
};

export function getCookieValue(cookie: string, key: string): string | undefined {
  if (!cookie) {
    return undefined;
  }
  const match = cookie.match(
    new RegExp("(?:^|; )" + key.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}
